module.exports = __webpack_public_path__ + "static/media/bc.d49cf8f2.svg";